// Central site configuration. Edit values here (names, date, links).
export const SITE = {
  monogram: "K & K",
  couple: "Kara & Kevin",
  first: "Kara",
  second: "Kevin",
  ampersand: "&",
  dateShort: "March 14, 2026",
  dateLong: "Saturday, the Fourteenth of March",
  year: "Two Thousand Twenty-Six",
  location: "The Fenway Hotel · Dunedin, Florida",
  hero: {
    // All-intra encode (every frame a keyframe) — required for smooth scrubbing
    video: "/media/hero.mp4",
    posterStart: "/media/poster_start.jpg",
    posterEnd: "/media/poster_end.jpg",
  },
  links: {
    // Professional gallery by Hello Photography (external, Pic-Time)
    gallery:
      "https://thehellophotography.pic-time.com/-karamargrafsproject/gallery?inviteptoken2=AAAAADcAAABV-4NxB5nwhBkWB4WL3AO0ww%2C%2C",
    // In-site gallery: photobooth + social are filtered views;
    // guestAlbum is everything, with guest uploads enabled.
    photobooth: "/gallery",
    social: "/gallery?album=social",
    guestAlbum: "/gallery?album=guest",
  },
};

// The Credits — every vendor who built the day. Rendered by CreditsSection.
export const CREDITS = [
  {
    role: "Planning",
    name: "Seashine Weddings",
    line: "Katie Conner held the whole day — and honestly, us — together. Every timeline. Every calm 'already handled.'",
    href: "https://www.seashineweddings.com",
  },
  {
    role: "Venue",
    name: "The Fenway Hotel",
    line: "Our jazz-age home on the water. Ashley and her team answered questions we hadn't thought to ask yet.",
    href: "https://www.fenwayhotel.com",
  },
  {
    role: "Welcome Party",
    name: "BayCare Ballpark",
    line: "Phillies baseball with all our favorite people in one grandstand. The only right way to start a wedding weekend.",
    href: "https://www.mlb.com/phillies/spring-training/ballpark",
  },
  {
    role: "Transport",
    name: "Clearwater Jolley Trolley",
    line: "Carried our crew to the ballpark and back, bells and all.",
    href: "https://www.clearwaterjolleytrolley.com",
  },
  {
    role: "Photography",
    name: "Hello Photography",
    line: "Amy photographed the day the way it felt. Every professional image on this site is her work, and we'll be staring at them for the rest of our lives.",
    href: "https://thehellophotography.pic-time.com/-karamargrafsproject/gallery?inviteptoken2=AAAAADcAAABV-4NxB5nwhBkWB4WL3AO0ww%2C%2C",
  },
  {
    role: "Hair",
    name: "Femme Akoi Beauty Studio",
    line: "The reason we walked into that ceremony feeling like the best versions of ourselves.",
    href: "https://www.femmeakoi.com",
  },
  {
    role: "Florals",
    name: "Leaf It To Us",
    line: "Every bloom in every photo on this site is their work. Exactly what we pictured when we closed our eyes.",
    href: "https://leafittous.net",
  },
  {
    role: "Rentals",
    name: "Gabro Event Services",
    line: "The tables we toasted at and the dance floor we wore out — all theirs.",
    href: "https://gabroeventservices.com",
  },
  {
    role: "DJ",
    name: "Breezin' Entertainment",
    line: "The soundtrack to the whole night, and the reason nobody sat down.",
    href: "https://www.breezin.com",
  },
  {
    role: "The Photo Bus",
    name: "Good Times Roll",
    line: "Every strip in the photobooth gallery rolled out of their bus. It was a hit before the first song ended.",
    href: "https://www.thegoodtimesroll.com",
  },
  {
    role: "Cigars",
    name: "Fuego Mobile Cigars",
    line: "The lounge on wheels. Half of the night's best conversations happened around Nathan's truck.",
    href: "https://www.fuegomobilecigars.com",
  },
  {
    role: "Content",
    name: "One Take Bridal",
    line: "Caught the day as it happened. We watched it back before the weekend was over.",
    href: "https://www.instagram.com/onetakebridal/",
  },
];

export default SITE;
